
import React from "react";
import { Subscription } from "@/types/subscription";
import SubscriptionForm from "../SubscriptionForm";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";

interface NewSubscriptionSectionProps {
  onSubmit: (data: Omit<Subscription, "id" | "totalPaid">) => Promise<Subscription>;
  isLoading: boolean;
}

export function NewSubscriptionSection({ onSubmit, isLoading }: NewSubscriptionSectionProps) {
  const { user, isAdmin } = useAuth();
  
  console.log("NewSubscriptionSection rendering with user:", user?.email);
  console.log("NewSubscriptionSection admin check:", isAdmin);
  
  // Hide subscription creation for admin users
  if (isAdmin) {
    console.log("NewSubscriptionSection: Admin user detected, hiding subscription form");
    return (
      <div className="bg-white p-6 rounded-lg shadow-md mb-8">
        <h2 className="text-xl font-semibold mb-4">Admin Mode</h2>
        <Alert className="mb-4 bg-yellow-50 border-yellow-400">
          <AlertCircle className="h-4 w-4 mr-2" />
          <AlertDescription>
            Creating new subscriptions is disabled in admin mode. You can view and manage existing subscriptions.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="bg-white p-6 rounded-lg shadow-md mb-8">
        <h2 className="text-xl font-semibold mb-4">New Subscription</h2>
        <Alert variant="warning" className="mb-4">
          <AlertCircle className="h-4 w-4 mr-2" />
          <AlertDescription>
            You need to be logged in to create a subscription.
          </AlertDescription>
        </Alert>
        <Button asChild className="w-full" variant="green">
          <Link to="/auth">Sign In or Create Account</Link>
        </Button>
      </div>
    );
  }

  return (
    <div className="bg-white p-6 rounded-lg shadow-md mb-8">
      <h2 className="text-xl font-semibold mb-4">New Subscription</h2>
      <SubscriptionForm 
        onSubmit={onSubmit}
        isLoading={isLoading}
      />
    </div>
  );
}
